export function Meter({ value, indeterminate = false }: { value?: number; indeterminate?: boolean }) {
  return (
    <div className={`meter${indeterminate ? " indeterminate" : ""}`}>
      <i style={indeterminate ? undefined : { width: `${Math.max(0, Math.min(100, value ?? 0))}%` }} />
    </div>
  );
}

export function MeterRow({ label, value, indeterminate }: { label: string; value?: number; indeterminate?: boolean }) {
  return (
    <div className="meter-row">
      <Meter value={value} indeterminate={indeterminate} />
      <span className="meter-label mono">{label}</span>
    </div>
  );
}

export function Spinner() {
  return <span className="spinner" role="status" aria-label="加载中" />;
}
